import { generatePlan, type FitnessProfile } from '@/lib/fitnessPlanGenerator';
import { normalizeFreeWorkoutItems } from './freeWorkoutBuilder';

export function buildWorkoutSuggestion(profile: FitnessProfile, minutes: number) {
  if (!Number.isInteger(minutes) || minutes < 10 || minutes > 120 || !Array.isArray(profile.equipment) || !profile.equipment.length) return [];
  const proposal = generatePlan({ ...profile, days_per_week: 2 }).days[0]?.exercises ?? [];
  const count = Math.min(proposal.length, Math.max(2, Math.floor(minutes / 6)));
  const setsWithinTime = Math.max(1, Math.floor((minutes * 60 - count * 30) / Math.max(1, count * 105)));
  return normalizeFreeWorkoutItems(proposal.slice(0, count).map(exercise => ({
    name: exercise.name, muscle: exercise.muscle, defaultWeight: 0,
    sets: Math.min(exercise.sets, setsWithinTime), defaultReps: Number.parseInt(exercise.reps, 10), restSeconds: 60,
  })));
}
